module.exports = __webpack_public_path__ + "img/Photo_9___Construction_986_63_3.d738c732.jpg";